import axios from "axios";

try {
  if (window.screen.width > 850) {
    let leftColumn = document.querySelector(".main-product-text");
    let rightColumn = document.querySelector(".garanthy");

    let rightMainColumn = document.querySelector(".right-column");
    let leftMainColumn = document.querySelector(".left-column");

    let leftColumnHeight = leftColumn.getBoundingClientRect().height;
    let rightColumnHeight = rightColumn.getBoundingClientRect().height;

    let rightMainColumnHeight = rightMainColumn.getBoundingClientRect().height;
    let leftMainColumnHeight = leftMainColumn.getBoundingClientRect().height;

    let separator = document.querySelector(".vertical-separator");

    if (leftColumnHeight > rightColumnHeight) {
      separator.style.cssText = "height: " + (leftColumnHeight - 20) + "px";
    } else {
      separator.style.cssText = "height: " + (rightColumnHeight - 20) + "px";
    }

    if (leftMainColumnHeight < rightMainColumnHeight) {
      leftMainColumn.style.cssText = "height: " + rightMainColumnHeight + "px";
    } else if (rightMainColumnHeight < leftMainColumnHeight) {
    }
  }
} catch {}
